import React from "react";
import { Link } from "react-router-dom";
import { timeSince } from "../util/utility";

interface ICategoryProps {
    slug: string;
    name: string;
    coverImage?: string;
    createdAt?: string;
    podcastCount?: number;
}

export const Category: React.FC<ICategoryProps> = ({
    slug,
    name,
    coverImage,
    createdAt,
    podcastCount,
}) => {
    const backgroundStyle = { backgroundImage: `url(${coverImage})` };

    return <Link to={{ pathname: `/category/${slug}` }}>
        <div className="bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 rounded-lg w-full flex flex-row flex-wrap p-3 antialiased bg-no-repeat bg-cover" style={coverImage ? backgroundStyle : {}}>
            <div className="md:w-2/3 w-full px-3 flex flex-row flex-wrap text-white">
                <div className="w-full font-semibold pt-3 md:pt-0">
                    <div className="text-4xl leading-tight mt-10 mb-10">{slug}</div>
                    <div className="flex items-end"><span className="pb-1"><b>{podcastCount}</b> Podcasts</span></div>
                    <div className="flex items-end pt-3 md:pt-0 bottom-0 right-0"><b>{timeSince(createdAt)}</b></div>
                </div>
            </div>
        </div>
    </Link >
};
